import {
  addObj,
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj
} from '@/api/gddlysjgclientparamserv'

export default {
  state: {
    state_GdDlysjgClientParam_AddObjResult: null,
    state_GdDlysjgClientParam_GetAllResult: null,
    state_GdDlysjgClientParam_SearchByNameResult: null,
    state_GdDlysjgClientParam_GetPageResult: null,
    state_GdDlysjgClientParam_GetDetailResult: null,
    state_GdDlysjgClientParam_ModifyObjResult: null,
    state_GdDlysjgClientParam_DeleteObjResult: null
  },
  mutations: {
    SET_GDDLYSJGCLIENTPARAM_ADDOBJ_RESULT: (state, rst) => {
      state.state_GdDlysjgClientParam_AddObjResult = rst
    },
    SET_GDDLYSJGCLIENTPARAM_GETALL_RESULT: (state, rst) => {
      state.state_GdDlysjgClientParam_GetAllResult = rst
    },
    SET_GDDLYSJGCLIENTPARAM_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_GdDlysjgClientParam_SearchByNameResult = rst
    },
    SET_GDDLYSJGCLIENTPARAM_GETPAGE_RESULT: (state, rst) => {
      state.state_GdDlysjgClientParam_GetPageResult = rst
    },
    SET_GDDLYSJGCLIENTPARAM_GETDETAIL_RESULT: (state, rst) => {
      state.state_GdDlysjgClientParam_GetDetailResult = rst
    },
    SET_GDDLYSJGCLIENTPARAM_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_GdDlysjgClientParam_ModifyObjResult = rst
    },
    SET_GDDLYSJGCLIENTPARAM_DELETEOBJ_RESULT: (state, rst) => {
      state.state_GdDlysjgClientParam_DeleteObjResult = rst
    }
  },
  actions: {
    GdDlysjgClientParamServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGCLIENTPARAM_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GDDLYSJGCLIENTPARAM_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GdDlysjgClientParamServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGCLIENTPARAM_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GDDLYSJGCLIENTPARAM_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GdDlysjgClientParamServ_SearchByName ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGCLIENTPARAM_SEARCHBYNAME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GDDLYSJGCLIENTPARAM_SEARCHBYNAME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GdDlysjgClientParamServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGCLIENTPARAM_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GDDLYSJGCLIENTPARAM_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GdDlysjgClientParamServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGCLIENTPARAM_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GDDLYSJGCLIENTPARAM_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GdDlysjgClientParamServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGCLIENTPARAM_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GDDLYSJGCLIENTPARAM_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GdDlysjgClientParamServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGCLIENTPARAM_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_GDDLYSJGCLIENTPARAM_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_GdDlysjgClientParam_AddObjResult: state => {
      return state.state_GdDlysjgClientParam_AddObjResult
    },
    get_GdDlysjgClientParam_GetAllResult: state => {
      return state.state_GdDlysjgClientParam_GetAllResult
    },
    get_GdDlysjgClientParam_SearchByNameResult: state => {
      return state.state_GdDlysjgClientParam_SearchByNameResult
    },
    get_GdDlysjgClientParam_GetPageResult: state => {
      return state.state_GdDlysjgClientParam_GetPageResult
    },
    get_GdDlysjgClientParam_GetDetailResult: state => {
      return state.state_GdDlysjgClientParam_GetDetailResult
    },
    get_GdDlysjgClientParam_ModifyObjResult: state => {
      return state.state_GdDlysjgClientParam_ModifyObjResult
    },
    get_GdDlysjgClientParam_DeleteObjResult: state => {
      return state.state_GdDlysjgClientParam_DeleteObjResult
    }
  }
}
